import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { GridRowIdGetter } from '@mui/x-data-grid/models/gridRows';

import { Country } from '../../types';
import { columns } from '../../columns';
import { data } from '../../data/en';

const getRowId: GridRowIdGetter<Country> = ({ name }) => {
  return data.findIndex((country) => country.name === name);
};

const Table = () => {
  return (
    <>
      <DataGrid
        columns={columns}
        rows={data}
        getRowId={getRowId}
        density="compact"
      />
    </>
  );
};

export default Table;
